// ----------------------------------------------------------------------

/** Brown used for user initial avatars (public dashboard). */
export const USER_INITIALS_AVATAR_BG = '#A67C52';

/** Up to two letters from a display name (e.g. "Allen Tsang" -> "AT"). */
export function nameToInitials(name: string, fallback = '?'): string {
  const trimmed = name?.trim() ?? '';
  if (!trimmed) return fallback;
  const parts = trimmed.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return (
      parts[0]!.charAt(0) + parts[parts.length - 1]!.charAt(0)
    ).toUpperCase();
  }
  const w = parts[0] ?? trimmed;
  return w.slice(0, 2).toUpperCase() || fallback;
}
